export default "__VITE_ASSET__C8VqmcIo__"